package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_19_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who are traveling on a long and winding path from Banshir to Seshiss. Today is Shimmer Eve — the last day of Newgrowth.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes see a red haired orc, armed with a long bow and spear, on the path ahead. He introduces himself as Obraxus and claims to be a guide of sorts. He suggests that the heroes could cut three days off their travel using a shortcut, and it would only cost 25 gold per day! Korvis is concerned that a short cut across rough terrain will be difficult for the cow. Tuesday is worried about hags, but there isn’t any indication that there would be more hags if the heroes decide to take the short cut. Falorn enthusiastically gives Obraxus 50 gold up front for the two days’ journey. Caper and Tuesday ask Obraxus about dragons — he heard a rumor about a green dragon in the west of the Greatmarsh.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When the heroes set up camp for the night, Obraxus offers them some of his booze, which Caper and Bigglesworth partake. The heroes build a big campfire and play instruments and dance around the campfire to celebrate Shimmer Eve. Obraxus stares lecherously at Caper.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During Caper’s night watch, she notices that Obraxus is awake. He comes over and chats. He is usually working further North. Caper asks him about Dwarven ruins and reflects on the heroes’ experience of discovering the ancient city of Karzak. Obraxus thinks that Dwarves aren’t very common in the Greatmarsh, and he pushes Caper on her reasons for visiting the Greatmarsh.")
    }
}
